import styled from "styled-components";

const PressableChildren = styled.div`
  position: relative;
  z-index: 4;
  width: 100%;
`;

export default PressableChildren;
